<template>
    <div class="tech-icon">
        <img :src="tech" alt="" >
    </div>
</template>

<script>
export default {
    name: "TechIcon",
    props: ['tech']
}
</script>

<style scoped lang="scss">
 .tech-icon {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background-color: #111;
          margin: 0 0.5rem;
          display: flex;
          justify-content: center;
          align-items: center;
          box-shadow: inset -2px -2px 4px hsla(0,0%,100%,.2),inset 2px 2px 4px rgba(0,0,0,.5);

            @media(min-width: 2250px) {
                width: 56px;
                height: 56px;
                margin: 0 1rem;
            }

           @media(max-width: 1024px) {
                width: 34px;
                height: 34px;   
        }

          @media(max-width: 768px) {
                width: 32px;
                height: 32px;   
        }
        @media(max-width: 350px) {
                width: 30px;
                height: 30px;   
                margin: 0 0.7rem 0 0;
        }
        }

        img {
            @media(min-width: 2250px) {
                width: 58%;
                height: 58%;
            }
            @media(max-width: 1024px) {
                width: 64%;
                height: 64%;
            }
            @media(max-width: 768px) {
                width: 60%;
                height: 60%;
            }
            @media(max-width: 350px) {
                width: 60%;
                height: 60%;
            }
        }

       
</style>